import { Form, Input, InputNumber, Switch, Row, Col, Button, Select} from 'antd';
import { useEffect } from 'react';
import {api} from '../helper/axios/index'


export const Password = ({handleResetDate, resetKey,loadingDate, handleUpdateDate})=>{

    const onFinish = (values) => {
        handleUpdateDate(values)
      };
    
      useEffect(() => {
        form.resetFields();
      }, [resetKey]);
    
      const [form] = Form.useForm();

    return(
        <Form form={form} onFinish={onFinish} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
        <Row gutter={16}>
          <Col span={12}>
          <Form.Item label="Ancien mot de Passe" name="old" rules={[{ required: true, message: 'L\'ancien mot de passe est obligatoires' }, { min: 4, message: 'Le mot de passe doit contenir au moins 4 caractères !' }]}>
               <Input.Password/>
          </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item label="Nouveau mot de Passe" name="new" rules={[{ required: true, message: 'Le nouveau mot de passe est obligatoires'}, { min: 4, message: 'Le mot de passe doit contenir au moins 4 caractères !' }]}>
               <Input.Password/>
          </Form.Item>
          </Col>
    
          <Col span={12} style={{marginTop: "20px"}}>
        <Form.Item>
          <Button style={{ width: '100%' }}  onClick={handleResetDate}>
            Annuler
          </Button>
        </Form.Item>
      </Col>
      <Col span={12} style={{marginTop: "20px"}}>
        <Form.Item>
          <Button loading={loadingDate} style={{ width: '100%' }} type="primary" htmlType="submit">
          Modifier
          </Button>
        </Form.Item>
      </Col>
        </Row>
        </Form>
    )
}